import React, { useState, useEffect } from 'react';
import useStyles from '../../../styles';
import { dateProtoObjectToString } from '../../../services/ConvertService';

import { TextField, Card, CardContent } from '@material-ui/core';
import { formatDollar } from '../../../lib/fmt';

export default function ClientSummaryBalanceFields({ value }) {
  const classes = useStyles();
  const [balanceData, setBalanceData] = useState({});
  useEffect(() => {
    setBalanceData({ ...value });
  }, [value]);

  return (
    <Card className={classes.root} variant="outlined">
      <CardContent>
        <div>
          <form noValidate autoComplete="off">
            <div className={classes.grdRow}>
              <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                <TextField
                  label="Trade Date"
                  type="date"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={balanceData.tradeDate}
                />
              </div>
              <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                <TextField
                  label="Account ID"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={balanceData.accountId}
                />
              </div>
              <div className={classes.grdCell1}>
                <TextField
                  label="Correspondent"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={balanceData.correspondent}
                />
              </div>
            </div>
            <div className={classes.grdRow}>
              <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                <TextField
                  label="Branch"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={balanceData.branch}
                />
              </div>
              <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                <TextField
                  label="Account No"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={balanceData.accountNo}
                />
              </div>
              <div className={classes.grdCell1}>
                <TextField
                  label="Sub Account No"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={balanceData.subAccountNo}
                />
              </div>
            </div>
            <div className={classes.grdRow}>
              <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                <TextField
                  label="Account Name"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={balanceData.accountName}
                />
              </div>
              <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                <TextField
                  label="Master Account No"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={balanceData.masterAccountNo}
                />
              </div>
              <div className={classes.grdCell1}>
                <TextField
                  label="Rep"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={balanceData.rep}
                />
              </div>
            </div>
            <div className={classes.grdRow}>
              <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                <TextField
                  label="Broker"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={balanceData.broker}
                />
              </div>
              <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                <TextField
                  label="Margin Type"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={balanceData.marginType}
                />
              </div>
              <div className={classes.grdCell1}>
                <TextField
                  label="Type"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={balanceData.type}
                />
              </div>
            </div>
            <div className={classes.grdRow}>
              <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                <TextField
                  label="Cash Balance"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={formatDollar(balanceData.cashBalance) || 0}
                />
              </div>
              <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                <TextField
                  label="Short Market Value"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={formatDollar(balanceData.shortMarketValue) || 0}
                />
              </div>
              <div className={classes.grdCell1}>
                <TextField
                  label="Long Market Value"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={formatDollar(balanceData.longMarketValue) || 0}
                />
              </div>
            </div>
            <div className={classes.grdRow}>
              <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                <TextField
                  label="Money Market"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={formatDollar(balanceData.moneyMarket) || 0}
                />
              </div>
              <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                <TextField
                  label="Adjusted Balance"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={formatDollar(balanceData.adjustedBalance) || 0}
                />
              </div>
              <div className={classes.grdCell1}>
                <TextField
                  label="Last Activity Date"
                  type="date"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={dateProtoObjectToString(balanceData.lastActivityDate)}
                />
              </div>
            </div>
            <div className={classes.grdRow}>
              <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                <TextField
                  label="Equity"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={formatDollar(balanceData.equity) || 0}
                />
              </div>
              <div
                className={classes.grdCell1}
                style={{ marginRight: 30 }}
              ></div>
              <div className={classes.grdCell1}></div>
            </div>
          </form>
        </div>
      </CardContent>
    </Card>
  );
}
